<template>
	<span class="input-select">
		<multiselect
			ref="ref"
			v-bind="{ ...$attrs, ...$props }"
			v-on="$listeners"
			:value="selected"
			@input="$emit('input', $event)"
			:options="options"
			:searchable="searchable"
			:allow-empty="empty"
			:preselect-first="preselectFirst"
			:taggable="taggable"
			:show-labels="false"
			:multiple="multiple"
			:close-on-select="closeOnSelect"
			:hide-selected="hideSelected"
			:show-no-options="true"
			:placeholder="placeholder"
			:disabled="disabled"
			:name="name"
			:id="id"
			label="name"
			tag-placeholder=""
			track-by="value"
		>
			<span slot="caret" slot-scope="{ toggle }" @mousedown.prevent.stop="toggle" class="caret">
				<svg-chevron-down />
			</span>
			<template slot="tag" slot-scope="{ option, remove }">
				<span class="multiselect__tag">
					<span>{{ option.name }}</span>
					<span @click="remove(option)" class="remove-tag">
						<svg-times class="remove-tag" />
					</span>
				</span>
			</template>

			<div slot="clear" slot-scope="{ search }" v-if="clearable" class="multiselect__clear">
				<span @mousedown.prevent.stop="$emit('clear', $event, search)" class="clear-results">
					<svg-times class="clear-results-icon" />
				</span>
			</div>

			<template slot="noOptions"> No more options available. </template>
		</multiselect>
	</span>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
	inheritAttrs: false,
	props: {
		options: {
			type: Array,
			required: true,
		},
		selected: {
			type: [Object, String, Array],
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		taggable: {
			type: Boolean,
			default() {
				return false;
			},
		},
		multiple: {
			type: Boolean,
			default() {
				return false;
			},
		},
		empty: {
			type: Boolean,
			default() {
				return true;
			},
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
		closeOnSelect: {
			type: Boolean,
			default() {
				return !this.multiple;
			},
		},
		preselectFirst: {
			type: Boolean,
			default() {
				return true;
			},
		},
		hideSelected: {
			type: Boolean,
			default() {
				return false;
			},
		},
		searchable: {
			type: Boolean,
			default() {
				return false;
			},
		},
		clearable: {
			type: Boolean,
			default() {
				return false;
			},
		},
		name: {
			type: String,
			default: '',
		},
		id: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss">
.input-select {
	display: inline-block;
	position: relative;

	.caret,
	.clear-results {
		position: absolute;
		top: 14px;
		right: 14px;
		z-index: 50;
		color: #9db3dc;

		svg {
			vertical-align: top;
			width: 10px;
			height: auto;
			transition: 0.2s;
			cursor: pointer;
		}
	}
	.caret + .multiselect__clear .clear-results {
		top: 13px;
		right: 38px;
		.clear-results-icon {
			width: 8px;
			height: auto;
		}
	}
}
</style>
